// The version this bundle was built at, which the version route also serves.
export const APOLLO_VERSION = "6.03";
export const APOLLO_CHANGELOG =
  "Restore effort color coding in workout builder, fix theme card height, improve playlist readability.";
